












import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Forms from '@/components/Forms.vue';
import { patchConnectedUser } from '@/api/api';
import User from '@/models/User';
import moment from 'moment';
import get from 'lodash/get';

@Component({
    components: {
        Forms,
    },
})
export default class ProfileUser extends Vue {
    error: string | null = null;
    errors: any = {};
    @Prop() user!: User;
    loading: boolean = false;
    type: string = 'edit';
    get items() {
        return [
            {
                name: 'civility',
                label: 'Civilité *',
                type: 'select',
                errorMessage: 'La civilité est requise',
                required: true,
                items: [
                    { text: 'Monsieur', value: 'Monsieur' },
                    { text: 'Madame', value: 'Madame' },
                ],
            },
            {
                name: 'firstname',
                label: 'Prénom *',
                type: 'text',
                errorMessage: 'Le prénom est requis',
                required: true,
            },
            {
                name: 'lastname',
                label: 'Nom *',
                type: 'text',
                errorMessage: 'Le nom est requis',
                required: true,
            },
            {
                name: 'email',
                label: 'Email *',
                type: 'text',
                errorMessage: "L'email est requis",
                required: true,
            },
            {
                name: 'phone',
                label: 'Téléphone',
                type: 'text',
            },
            {
                name: 'mobile',
                label: 'Mobile',
                type: 'text',
            },
            {
                name: 'birthdate',
                label: 'Date de naissance',
                type: 'date',
            },
            {
                name: 'address',
                type: 'address',
                fields: {
                    street: {
                        label: 'Adresse',
                        name: 'street',
                    },
                    street2: {
                        label: `Complément d'adresse`,
                        name: 'street2',
                    },
                    postal_code: {
                        label: 'Code postal',
                        name: 'postal_code',
                    },
                    city: {
                        label: 'Ville',
                        name: 'city',
                    },
                },
            },
        ];
    }
    defaultValue: any | null = {
        civility: null,
        firstname: null,
        lastname: null,
        company: null,
        roles: null,
        email: null,
        birthdate: null,
        phone: null,
        mobile: null,
        address: {
            street: null,
            street2: null,
            postal_code: null,
            city: null,
        },
        country: null,
        enabled: false,
    };

    mounted() {
        this.onUser();
    }

    @Watch('user')
    onUser() {
        this.loading = true;
        if (this.user) {
            this.defaultValue.civility = this.user.civility || null;
            this.defaultValue.firstname = this.user.firstname || null;
            this.defaultValue.lastname = this.user.lastname || null;
            this.defaultValue.company = this.user.company
                ? this.user.company.id
                : null;
            this.defaultValue.email = this.user.email || null;
            this.defaultValue.birthdate =
                (this.user.birthdate &&
                    moment(this.user.birthdate).format('YYYY-MM-DD')) ||
                null;
            this.defaultValue.phone = this.user.phone || null;
            this.defaultValue.mobile = this.user.mobile || null;
            this.defaultValue.address.street =
                (this.user.address && this.user.address.street) || null;
            this.defaultValue.address.street2 =
                (this.user.address && this.user.address.street2) || null;
            this.defaultValue.address.postal_code =
                (this.user.address && this.user.address.postal_code) || null;
            this.defaultValue.address.city =
                (this.user.address && this.user.address.city) || null;
            this.defaultValue.address.country =
                (this.user.address && this.user.address.country) || null;
            this.defaultValue.enabled = this.user.enabled;
        }
        this.loading = false;
    }

    async submit(form: any) {
        this.loading = true;
        const newUser: User = {
            civility: form.civility,
            firstname: form.firstname,
            lastname: form.lastname,
            email: form.email,
            birthdate: form.birthdate,
            phone: form.phone,
            mobile: form.mobile,
            address: {
                street: form.address.street,
                street2: form.address.street2,
                postal_code: form.address.postal_code,
                city: form.address.city,
            },
            enabled: form.enabled,
        };

        const $vs = (this as any).$vs;
        try {
            await patchConnectedUser(newUser);
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Modification',
                text: `Modification du réussie`,
            });
        } catch (error) {
            this.errors = error.response.data.errors.children;
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Erreur lors de la soumission du formulaire',
            });
        } finally {
            this.loading = false;
        }
    }
}
